// extracted by mini-css-extract-plugin
export default {"wrapper":"NextButton_wrapper__rhOmT"};